import { render, staticRenderFns } from "./Splitter.vue?vue&type=template&id=4871c06c"
import script from "./Splitter.vue?vue&type=script&lang=js"
export * from "./Splitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports